import { render } from "./AuHelp.vue?vue&type=template&id=25f822f0&scoped=true"
const script = {}

import "./AuHelp.vue?vue&type=style&index=0&id=25f822f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25f822f0"]])

export default __exports__